<template>
  <table style="width:100%">
    <tr v-for="colAtt in columnsAtt">
      <th>{{titles[colAtt]}}</th>
    </tr>
    <tr v-for="row in dataArr">
      <td v-for="colAtt in columnsAtt">{{row[colAtt]}}</td>
    </tr>
  </table>
</template>

<script>
  export default {
    name: "Table",
    dataArr:{
      type: Array
    },
    columnsAtt: {
      type: Array
    },
    titles:{
      type: Array
    }
  }
</script>

<style scoped>

</style>
